import { jsx, jsxs } from "react/jsx-runtime";
import { Paragraph, SizableText, XStack, YStack } from "tamagui";
function TextDemo() {
  return /* @__PURE__ */ jsxs(YStack, { space: "$2", alignItems: "center", children: [
    /* @__PURE__ */ jsx(SizableText, { size: "$3", children: "SizableText" }),
    /* @__PURE__ */ jsxs(XStack, { space: true, children: [
      /* @__PURE__ */ jsx(SizableText, { theme: "alt1", size: "$3", children: "alt1" }),
      /* @__PURE__ */ jsx(SizableText, { theme: "alt2", size: "$3", children: "alt2" })
    ] }),
    /* @__PURE__ */ jsx(Paragraph, { size: "$2", fontWeight: "800", children: "Paragraph" })
  ] });
}
export {
  TextDemo
};
//# sourceMappingURL=TextDemo.js.map
